import React from "react";
import { Controller, useFormContext } from "react-hook-form";

import Checkbox from "../../FormElement/Checkbox";

interface IHookFormCheckboxProps extends React.ComponentProps<"input"> {
  name: string;
  label?: string;
  labelClassName?: string;
}

export const HookFormCheckbox = (props: IHookFormCheckboxProps) => {
  const { name, label, labelClassName, className, disabled } = props;

  const { control } = useFormContext();

  return (
    <div className={`hook-form-checkbox ${className || ""}`}>
      <Controller
        control={control}
        name={name}
        render={({ field }) => (
          <Checkbox
            checked={field.value}
            id={name}
            label={label}
            labelClassName={labelClassName}
            onChange={field.onChange}
            disabled={disabled}
          />
        )}
      />
    </div>
  );
};
